/**
 * Generate number depending on page, number of rows, sort order
 */

export default {
  methods: {
    generateNumber (index, page, row, order, max) {
      return order === 'desc' ? max - page * row + row - index
        : max - (max - index - 1) + row * (page - 1)
    }
  }
}
